// extracted by mini-css-extract-plugin
export var alertIcon = "_u4-0";